import React from 'react';
import { useForm } from 'react-hook-form';
import { useModalClose } from '../../../utils/useModalClose';
import useSWRMutation from 'swr/mutation';
import { trpc } from '../../../api/trpc';
import { InputWrapper } from '../../common/input-wrapper';
import { AlertService } from '../../../services/alert.service';

type Props = {
  close: (value?: boolean) => void;
  reject: () => void;
  orderId: string;
};

type FormValues = {
  comment?: string;
};

export const PurchaseOrderExternalDelivery: React.FC<Props> = ({
  close,
  orderId,
  reject,
}) => {
  const {
    handleSubmit,
    register,
    formState: { errors },
  } = useForm<FormValues>();

  const { trigger: sendToExternal, isMutating } = useSWRMutation(
    ['purchaseOrder.markSentToExternal'],
    (_key, { arg }: { arg: { id: string; comment?: string } }) =>
      trpc.purchaseOrder.admin.markSentToExternal.mutate(arg),
  );

  const onSubmit = handleSubmit(async (data) => {
    try {
      await sendToExternal({
        id: orderId,
        comment: data.comment,
      });
      AlertService.success();
      close(true);
    } catch (e: any) {
      AlertService.error(e?.message ?? 'Ошибка отправки');
    }
  });

  const modalRef = useModalClose(reject);

  return (
    <div className="modal-dialog mw-400" ref={modalRef}>
      <div className="modal-content">
        <div className="modal-header border-bottom-0 p-4">
          <button
            type="button"
            className="btn-close"
            onClick={() => reject()}
          />
        </div>

        <form className="modal-body pt-2 p-4" onSubmit={onSubmit}>
          <div className="text-center mb-4 mx-auto">
            <i className="bi bi-exclamation-circle-fill color-gray-600 fs-65 lh-1" />
            <h3 className="mt-3">Вы отправляете заказ на внешнюю доставку</h3>
          </div>

          <InputWrapper
            title="Комментарий"
            className="mb-5"
            error={errors.comment?.message}
          >
            <textarea
              className="form-control"
              placeholder={'Вы можете оставить комментарий'}
              {...register('comment')}
            />
          </InputWrapper>

          <div className="d-flex gap-2">
            <button
              type="submit"
              className="btn btn-success w-50"
              disabled={isMutating}
            >
              {isMutating ? 'Отправка...' : 'Подтвердить'}
            </button>

            <button
              type="button"
              className="btn btn-secondary text-white w-50"
              onClick={() => reject()}
            >
              Отмена
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};
